import { defineStore } from 'pinia'

export const useStore = defineStore('storeId', {
  state: () => {
    return {
      tree_corpId: '',
      tree_departId:'',
      tbuser:0
    }
  },
  getters:{},
  actions:{}
})
